import React from 'react';

const MiniAppConfigFormModal = React.lazy(() => import('../components/FormModal'));
const miniAppConfigModalRegistry = {
    core_miniAppConfigId: MiniAppConfigFormModal
};
export default miniAppConfigModalRegistry;
